import Vue from 'vue';
import moment from 'moment';
import '../../../../filters';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'Manpowers',
  components: {
    ManpowerComp: require('./manpower.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      manpowers: [],
      rateTypes: [],
      employees: [],
      allowances: [],
      teams: [],
      stations: [],
      bManpowerDialog: false,
      bConfirmDialog: false,
      showRates: false,
      useHours: true,
      deleteConfirmMessage: '',
      editingManpower: {

      },
      editingManpowerClone: {

      },
      message: '',
    }
  },
  created() {
    console.log("manpower data", this.dataObj);
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_jobcard_updated', this.init);
    this.init();
  },
  methods: {
    formatMoney(number, decPlaces, decSep, thouSep) {
      decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSep = typeof decSep === "undefined" ? "." : decSep;
      thouSep = typeof thouSep === "undefined" ? "," : thouSep;
      var sign = number < 0 ? "-" : "";
      var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - parseInt(i)).toFixed(decPlaces).slice(2) : "");
    }, //this.formatMoney(item.closingBalance, 2, '.', ',');
    init() {
      Vue.nextTick(() => {
        this.dataObj.appData.actualManpowerUsages.forEach(p => {
          p.totalCost = this.formatMoney(p.totalCost, 2, '.', ',');
          if (!p.uuid || p.uuid.length === 0)
            p.uuid = uuidv4();
        });
        if (this.dataObj.appData.actualManpowerUsages)
          this.manpowers = this.dataObj.appData.actualManpowerUsages;
        else
          this.dataObj.appData.actualManpowerUsages = [];

        this.rateTypes = this.dataObj.appData.rateTypes;
        this.employees = this.dataObj.appData.employees;
        this.allowances = this.dataObj.appData.employeeAllowances;
        this.teams = this.dataObj.appData.teams;
        this.stations = this.dataObj.appData.stations;
        this.showRates = this.dataObj.appData.showManPwrRates;
        this.useHours = this.dataObj.appData.settings.useHours;
      });
    },
    addManpower() {
      this.editingManpowerClone = {
        selection: [],
        additionalCost: 0,
        allowance: '',
        allowanceId: 0,
        comment: '',
        dt: this.dataObj.appData.startDt,
        employee: '',
        employeeId: 0,
        id: 0,
        isAllowance: false,
        showManpowerRates: !this.dataObj.appData.settings.showManpowerRates ? false : this.dataObj.appData.settings.showManpowerRates,
        isMultiple: true,
        rateHr: 0,
        rateType: '',
        rateTypeId: 0,
        totalCost: 0,
        travelDuration: this.dataObj.appData.actualTravelDuration,
        workDuration: this.dataObj.appData.actualJobDuration,
        showRates: this.showManPwrRates,
        useHours: this.useHours,
        uuid: uuidv4(),
        editCustomer: false,
        assignedEmployeeId: this.dataObj.appData.assignedEmployeeId,
        applicationStationId: this.dataObj.appData.applicationStationId,
        stationId: this.dataObj.appData.stationId
      };
      this.editingManpowerClone.rateTypes = this.rateTypes;
      this.editingManpowerClone.employees = this.employees;
      this.editingManpowerClone.allowances = this.allowances;
      this.editingManpowerClone.teams = this.teams;
      this.editingManpowerClone.stations = this.stations;
      this.editingManpowerClone.maxJobDuration = this.dataObj.appData.actualJobDuration;
      this.editingManpowerClone.maxTravelDuration = this.dataObj.appData.actualTravelDuration;

      this.$root.$emit('reset_select_from_list');
      this.bManpowerDialog = true;
    },
    editManpower(item) {
      //console.log("item editing man clone", item);
      this.editingManpower = item;
      this.editingManpowerClone = JSON.parse(JSON.stringify(item));

      this.editingManpowerClone.rateTypes = this.rateTypes;
      this.editingManpowerClone.rateType = item.rateType;
      this.editingManpowerClone.rateTypeId = item.rateTypeId;
      this.editingManpowerClone.employees = this.employees;
      this.editingManpowerClone.allowances = this.allowances;
      this.editingManpowerClone.showManpowerRates = !this.dataObj.appData.settings.showManpowerRates ? false : this.dataObj.appData.settings.showManpowerRates;
      this.editingManpowerClone.teams = this.teams;
      this.editingManpowerClone.stations = this.stations;
      this.editingManpowerClone.isMultiple = false;
      this.editingManpowerClone.showRates = this.showManPwrRates;
      this.editingManpowerClone.useHours = this.useHours;
      this.editingManpowerClone.selection = [];
      this.editingManpowerClone.maxJobDuration = this.dataObj.appData.actualJobDuration == null ? '0' : this.dataObj.appData.actualJobDuration;
      this.editingManpowerClone.maxTravelDuration = this.dataObj.appData.actualTravelDuration == null ? '0' : this.dataObj.appData.actualTravelDuration;
      this.editingManpowerClone.editCustomer = true;
      //console.log("editing man pow", this.editingManpowerClone);
      this.bManpowerDialog = true;
    },
    removeConfirm(item) {
      this.deleteConfirmMessage = this.$t('omApplication.DeleteManpower') + ' [' + item.id + '. ' + item.employee + '] ?';
      this.editingManpower = item;
      this.bConfirmDialog = true;
    },
    removeManpower() {
      this.dataObj.appData.actualManpowerUsages = this.dataObj.appData.actualManpowerUsages.filter(p => p.uuid !== this.editingManpower.uuid);
      this.manpowers = this.dataObj.appData.actualManpowerUsages;
    },
    saveManpower() {
      //console.log("workDuration", this.editingManpowerClone.workDuration, " > maxJobDuration", this.editingManpowerClone.maxJobDuration);
      //console.logconsole.log("editingManpowerClone save", this.editingManpowerClone);

      if (this.editingManpowerClone.workDuration > this.editingManpowerClone.maxJobDuration || parseInt(this.editingManpowerClone.workDuration) < 0)
        this.$alertMsg(this.$t('validation.invalidWorkDuration'));

      if (this.editingManpowerClone.travelDuration > this.editingManpowerClone.maxTravelDuration)
        this.$alertMsg(this.$t('validation.invalidTravelDuration'));

      if (this.editingManpowerClone.workDuration > this.editingManpowerClone.maxJobDuration || this.editingManpowerClone.travelDuration > this.editingManpowerClone.maxTravelDuration || parseInt(this.editingManpowerClone.workDuration) < 0)
        return;


      this.dataObj.appData.actualManpowerUsages = this.dataObj.appData.actualManpowerUsages.filter(p => p.uuid !== this.editingManpowerClone.uuid);
      const selection = this.editingManpowerClone.selection;
      delete this.editingManpowerClone.rateTypes;
      delete this.editingManpowerClone.showManpowerRates;
      delete this.editingManpowerClone.employees;
      delete this.editingManpowerClone.allowances;
      delete this.editingManpowerClone.isMultiple;
      delete this.editingManpowerClone.useHours;
      delete this.editingManpowerClone.showManPwrRates;
      delete this.editingManpowerClone.teams;
      delete this.editingManpowerClone.stations;
      delete this.editingManpowerClone.maxJobDuration;
      delete this.editingManpowerClone.maxTravelDuration;


      selection.forEach(p => {
        const manPower = JSON.parse(JSON.stringify(this.editingManpowerClone));
        const employee = this.employees.filter(e => e.employeeId === p.id)[0];
        //console.log("emp", employee);
        manPower.employeeId = p.id;
        manPower.orgPost = employee.orgPostName;
        manPower.rateHr = p.rate;
        manPower.employee = employee.displayString;
        manPower.uuid = uuidv4();
        manPower.minimumCharge = employee.minimumCharge;
        var singleCost = manPower.workDuration * parseFloat(p.rate) / 60 + manPower.travelDuration * parseFloat(p.rate) / 60;
        manPower.totalCost = employee.minimumCharge > singleCost ? employee.minimumCharge : singleCost;
        manPower.totalCost = manPower.totalCost.toFixed(2);
        manPower.additionalCost = employee.minimumCharge > singleCost ? employee.minimumCharge - singleCost : 0;
        manPower.additionalCost = manPower.additionalCost.toFixed(2);

        this.dataObj.appData.actualManpowerUsages.push(manPower);
        
      });


      //if (this.isMultiple === false) {
      //  this.dataObj.appData.actualManpowerUsages.push(this.editingManpowerClone);
      //  console.log("in", this.dataObj.appData.actualManpowerUsages)
      //}
      //else {
      //  //console.log("selection for save", selection);
      //  selection.forEach(p => {
      //    const manPower = JSON.parse(JSON.stringify(this.editingManpowerClone));
      //    const employee = this.employees.filter(e => e.employeeId === p.id)[0];
      //    manPower.employeeId = p.id;
      //    manPower.rateHr = p.rate;
      //    manPower.employee = employee.displayString;
      //    manPower.uuid = uuidv4();
      //    manPower.minimumCharge = employee.minimumCharge;
      //    var singleCost = manPower.workDuration * parseFloat(p.rate) / 60 + manPower.travelDuration * parseFloat(p.rate) / 60;
      //    manPower.totalCost = employee.minimumCharge > singleCost ? employee.minimumCharge : singleCost;
      //    manPower.totalCost = manPower.totalCost.toFixed(2);
      //    manPower.additionalCost = employee.minimumCharge > singleCost ? employee.minimumCharge - singleCost : 0;
      //    manPower.additionalCost = manPower.additionalCost.toFixed(2);

      //    this.dataObj.appData.actualManpowerUsages.push(manPower);
      //  });
      //}

      this.manpowers = this.dataObj.appData.actualManpowerUsages;
      //console.log("man", this.dataObj.appData.actualManpowerUsages);
      this.closeDialog();
    },
    closeDialog() {
      //console.log(this.dataObj.appData);
      this.bManpowerDialog = false;
    },
  },
  
}

